import { useState } from "react";
import { combine_text } from "../functions/combine_text";
import { Score } from "../types/score";
import { useTimer } from "./use_timer";

export const usePractice: (text: string[]) => [string[][], Score, Score, () => void, (key: String) => void] = (text: string[]) => {
	const [isRunning, setIsRunning] = useState(false);
	const [time, startTimer, stopTimer] = useTimer()
	const [mistakes, setMistakes] = useState(0);
	const [highscore, setHighScore] = useState<Score>({ time: 0, mistakes: 0 })
	const [practiceText, setPracticeText] = useState<Array<string>>([])

	const start = () => {
		if (!isRunning) {
			setPracticeText(text)
			startTimer()
			setMistakes(0)
			setIsRunning(true)
		}
	}
	
	const stop = () => {
		setIsRunning(false)
		stopTimer()
		let isBetter = time <= highscore.time && mistakes <= highscore.mistakes
		if (isBetter || highscore.time === 0) {
			setHighScore({ time, mistakes })
		}
	}

	const receive_key = (key: String) => {
		if (isRunning) {
			let idx = text.length;
			if (idx < practiceText.length) {
				if (key !== practiceText[idx]) {
					setMistakes(mistakes + 1)
				} else if (idx + 1 >= practiceText.length) {
					stop()
				}
			}
		}
	}

	let output_text: string[][] = [text, [], []];

	if (isRunning) {
		output_text = combine_text(text, practiceText)
	}

	return [
		output_text,
		{time, mistakes},
		highscore,
		start,
		receive_key
	]
}